import ol_Feature from 'ol/Feature';
import ol_source_Vector from 'ol/source/Vector';
import ol_layer_Vector from 'ol/layer/Vector';
import ol_Collection from 'ol/Collection';

/**
 * A layer with draw area. Only draw one feature at a time.
 * @constructor
 * @extends {ol.layer.Vector}
 * @param {Object} opt_options Control options, extends olx.layer.VectorOptions.
 */
export default class SingleFeature extends ol_layer_Vector {
  constructor(opt_options) {
    const options = opt_options || {};

    options.source = new ol_source_Vector({
      features: new ol_Collection(),
    });

    super(options);
  }

  /**
     * Sugar to draw a geometry.
     * @param {ol.geom.Geometry} geometry A geometry.
     */
  drawGeometry(geometry) {
    this.drawFeature(new ol_Feature(geometry));
  }

  /**
     * Draw a feature in the layer.
     * @param {ol.Feature} feature The feature to draw.
     */
  drawFeature(feature) {
    this.clear();
    if (feature) {
      this.getSource().addFeature(feature);
    }
  }

  /**
     * Clear the features.
     */
  clear() {
    this.getSource().clear();
  }
}
